import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {MainInfo} from "fragments";
import {employeesBody, employeesHead, emptyState} from "./constants";
import {AddEmployee} from "./fragments";
import {FindSuccess, limit, useModal} from "utils";
import {DeleteModal} from "components";
import {employeesActions, httpRequestsOnSuccessActions} from "store";
import {EmployeesSingle} from "./employeesSingle";

const ACTION_TYPE = "GET_EMPLOYEES";
const ACTION_DELETE = "DELETE_EMPLOYEES";
const ACTION_CHANGE_STATUS = "CHANGE_STATUS_EMPLOYEES";


export const Employees = () => {
    const employeesList = useSelector((state) => state.employees?.employeesList);
    const dispatch = useDispatch();
    const location = useLocation();
    const {openModal, close} = useModal();
    const successChangeStatus = FindSuccess(ACTION_CHANGE_STATUS);
    const info = location?.state;


    const getEmployees = (noLoad) => {
        const params = {
            ...info,
        };
        params.skip = info?.skip ? info?.skip : 0;
        params.limit = limit;

        dispatch(employeesActions.getEmployees(params, noLoad));
    }


    useEffect(() => {
        if (successChangeStatus?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_CHANGE_STATUS));
            getEmployees(true)
        }
    }, [successChangeStatus]);

    useEffect(() => {
        getEmployees();
    }, [info]);

    const addEmployee = (item) => {
        openModal(
            <AddEmployee info={item} afterSuccess={() => getEmployees(true)}/>, {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 850
            });
    };

    const handleDelete = (item) => {
        openModal(
            <DeleteModal
                handleDelete={() => {
                    dispatch(employeesActions.deleteEmployee(item?.id));
                }}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${item?.name} ?`}
                afterSuccess={() => {
                    getEmployees(true);
                    close();
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const handleClickRow = (item) => {
        openModal(
            <EmployeesSingle item={item} afterSuccess={() => getEmployees(true)}/>, {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 1276
            });
    };

    return (
        <div className="employees-page-wrapper ">
            <MainInfo
                buttonText="Add Employee"
                headerTable={employeesHead()}
                bodyTable={employeesBody({
                    handleDelete,
                    handleEit: (item) => addEmployee(item),
                })}
                clickToAddButton={() => addEmployee()}
                listTable={employeesList?.employees}
                listCountTable={employeesList?.count}
                actionType={ACTION_TYPE}
                handleClickRow={handleClickRow}
                emptyState={emptyState(addEmployee)}
            />
        </div>
    );
};
